import { MatDialogConfig } from "@angular/material/dialog";
import { ConfirmDialogData } from "../../../shared/dialogs/confirm-dialog/confirm-dialog.component";

export const CLOSE_ACTION_PLAN_DIALOG_CONFIG: MatDialogConfig<ConfirmDialogData> =
  {
    data: {
      title: "Close action plan",
      message: "Do you want to close this Action Plan?",
      inputForm: [
        [
          {
            formControlName: "comment",
            label: "comment",
            placeholder: "comment",
            value: undefined,
            validators: {
              required: true,
            },
            template: "input",
            disabled: false,
          },
        ],
      ],
    },
  };
